import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
let backendURL = process.env.REACT_APP_backend_url;
// Utility to read cookie
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return decodeURIComponent(parts.pop().split(";").shift());
  return null;
}

// Utility to save cookie
function setCookie(name, value, days = 30) {
  const expires = new Date(Date.now() + days * 86400000).toUTCString();
  // Omit domain for local development; add domain=.vnrzone.site for production
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; expires=${expires}; SameSite=Lax`;
  // For production, use:
  // document.cookie = `${name}=${encodeURIComponent(value)}; path=/; domain=.vnrzone.site; expires=${expires}; SameSite=Lax`;
}
async function logout() {
  try {
    const response = await fetch(`${backendURL}/logout`, {
      method: "POST", // or GET based on your Flask route
      credentials: "include", // ✅ important to include cookies
    });

    if (response.ok) {
      console.log("Logout successful!");
      // Redirect or update UI
      // window.location.href = "/login";
    } else {
      console.error("Logout failed.");
    }
  } catch (err) {
    console.error("Error during logout:", err);
  }
}


// Utility to delete cookie
function deleteCookie(name) {
  // Omit domain for local development; add domain=.vnrzone.site for production
  // document.cookie = `${name}=; path=/; max-age=0`;
  logout()
  console.log("called...")
  document.cookie='userToken=;path=/;domain=dev-projecthub.vnrzone.site;max-age=0';
  // For production, use:
  document.cookie = `${name}=; path=/; domain=dev-projecthub.vnrzone.site; max-age=0`;
  // Most reliable combo
document.cookie = "vnrzone_user=; path=/; max-age=0";
document.cookie = "vnrzone_user=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";

}

// Load user from cookie for initial state
const loadInitialState = () => {
  const cookie = getCookie("vnrzone_user");
  if (!cookie) {
    console.warn("No vnrzone_user cookie found");
    return {
      loginStatus: false,
      currentUser: null,
    };
  }
  try {
    const savedUser = JSON.parse(cookie);
    // Validate cookie structure
    if (
      typeof savedUser !== "object" ||
      typeof savedUser.loginStatus !== "boolean" ||
      (savedUser.currentUser !== null && typeof savedUser.currentUser !== "object")
    ) {
      console.warn("Invalid vnrzone_user cookie structure:", savedUser);
      return {
        loginStatus: false,
        currentUser: null,
      };
    }
    console.log("Loaded vnrzone_user cookie:", savedUser);
    return {
      loginStatus: savedUser.loginStatus,
      currentUser: savedUser.currentUser,
    };
  } catch (error) {
    console.error("Failed to parse vnrzone_user cookie:", error);
    return {
      loginStatus: false,
      currentUser: null,
    };
  }
};

// Async logout thunk
export const logoutThunk = createAsyncThunk("user/logout", async () => {
  // Perform any async operations (e.g., API call to invalidate session)
  return true;
});

const userSlice = createSlice({
  name: "User",
  initialState: loadInitialState(),
  reducers: {
    setCurrentUser: (state, action) => {
      console.log("setCurrentUser action:", action);
      state.currentUser = action.payload;
      saveToCookie(state);
    },
    setLoginStatus: (state, action) => {
      console.log("setLoginStatus action:", action);
      state.loginStatus = action.payload;
      saveToCookie(state);
    },
    setCookieFun: (state, action) => {
      console.log("setCookieFun action:", action);
      saveToCookie(state);
    },
    resetState: (state) => {
      console.log("resetState action");
      const initialState = loadInitialState();
      state.loginStatus = initialState.loginStatus;
      state.currentUser = initialState.currentUser;
      saveToCookie(state);
    },
    logoutState: (state) => {
      console.log("logoutState action is going on...");
      state.loginStatus = false;
      state.currentUser = null;
      deleteCookie("vnrzone_user");

    },
  },
  extraReducers: (builder) => {
    builder.addCase(logoutThunk.fulfilled, (state) => {
      console.log("logoutThunk fulfilled");
      state.loginStatus = false;
      state.currentUser = null;
      deleteCookie("vnrzone_user");
    });
  },
});

function saveToCookie(state) {
  const userData = JSON.stringify({
    loginStatus: state.loginStatus,
    currentUser: state.currentUser,
  });
  console.log("Saving to vnrzone_user cookie:", userData);
  setCookie("vnrzone_user", userData);
}

export const { setCurrentUser, setLoginStatus, resetState, logoutState, setCookieFun } = userSlice.actions;
export default userSlice.reducer;